var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaySkipBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#FED241",
    strokeOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.25C18.75 17.5596 18.1904 17 17.5 17C16.8096 17 16.25 17.5596 16.25 18.25V27.75C16.25 28.4404 16.8096 29 17.5 29C18.1904 29 18.75 28.4404 18.75 27.75V18.25Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4614 23.7158C18.9076 23.3993 18.9076 22.6007 19.4614 22.2842L28.5166 17.1098C29.0662 16.7958 29.75 17.1926 29.75 17.8256V28.1744C29.75 28.8074 29.0662 29.2042 28.5166 28.8902L19.4614 23.7158Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySkipBack);
export default __webpack_public_path__ + "static/media/play-skip-back.d48516c45d457c08e7f0643e84bcef98.svg";
export { ForwardRef as ReactComponent };